import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { HandleError, HttpErrorHandler } from '../../../util/http-error-handler.service';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Usuario } from '../../../models/usuario';

const API_URL = environment.apiUrl;


@Injectable({
  providedIn: 'root'
})
export class UsuariosService {
  private handleError: HandleError;
  menuItems: Array<any>;

  constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
    this.menuItems = [];
    this.handleError = httpErrorHandler.createHandleError('CentroDeCustoService');
  }

  obterTodos(param: any, direcao: string, propriedade: string): Observable<any> {
    const params = new HttpParams()
      .set('Direcao', `${(direcao)}`)
      .set('Propriedade', `${(propriedade)}`)
      .set('pageNumber', `${param.offset}`)
      .set('pageSize', `${param.limit}`)
      .set('descricao', `${param.descricao}`)
      .set('conta', `${param.conta}`);
    return this.http.get<any>(API_URL + "users", { params })
      .pipe(
        catchError(this.handleError('obterTodos', []))
      );
  }
  obterPorCodigo(id: number): Observable<any> {
    return this.http.get<any>(API_URL + "users/" + id)
      .pipe(
        catchError(this.handleError('obterPorCodigo', []))
      );
  }

  alterarSenha(record: any): Observable<any> {
    return this.http.put<any>(API_URL + "users/changepassword", record)
      .pipe(
        catchError(this.handleError('changepassword', record))
      );
  }

  atualizarUsuario(usuario: Usuario): Observable<any> {
    return this.http.put<Usuario>(API_URL + "users/updateinformations", usuario)
      .pipe(
        catchError(this.handleError('usuarios', usuario))
      );
  }
}
